import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { REFERRAL_TRACKING } from '@referrals/utils/trackingEvents';
import { Tappable, Modal } from '@common/ui/general';
import { toggleReferralProgramSelect } from '@referrals/stores/home';
import ReferralProgramOptions from '~referral/ui/ReferralProgramOptions';
import analytics from '@referrals/analytics';
import Tick from '~referral/images/icons/success-tick.svg';

const EndStateModal = ({ endState, isEndState, hasUGAccess = false }) => {
  const dispatch = useDispatch();
  const desc = {
    title: 'You will receive a call from your referral manager soon!',
    subTitle: `They will guide you on the entire 
    referral process.`,
    btnText: 'Try the Referral Rewards Calculator',
  };

  const descSst = {
    title: 'You will receive a call from our team soon',
    subTitle: `They will guide you on the entire 
    referral process.`,
    btnText: 'Try the Referral Rewards Calculator',
  };

  const onCloseEndStateModal = useCallback(() => {
    isEndState(false);
    dispatch(toggleReferralProgramSelect(true));
  }, [dispatch, isEndState]);

  const openRewardsCalcModal = () => {
    analytics.view(REFERRAL_TRACKING.viewRewardsCalc,
      'Post Linkedin share end state');
    analytics.click(REFERRAL_TRACKING.clickRewardsCalcBtn,
      'Post Linkedin share end state');
  };

  useEffect(() => {
    analytics.view(
      REFERRAL_TRACKING.acknowledgementModalView,
      'Referral Acknowledgement Modal',
    );
  }, []);

  return (
    <Modal
      isOpen={endState}
      onClose={onCloseEndStateModal}
      className="nudge-shared-modal"
      hasCloseButton
      withoutHeader
    >
      <div className="end-state__container">
        <div className="end-state__content-container">
          <div className="end-state__img-container">
            <img
              src={Tick}
              alt="tick"
              className="end-state__img"
            />
          </div>
          <div className="end-state__title">
            {
              hasUGAccess ? (descSst.title) : (desc.title)
            }
          </div>
          <div className="end-state__sub-title">
            {
              hasUGAccess ? (descSst.subTitle) : (desc.subTitle)
            }
          </div>
        </div>
        <ReferralProgramOptions className="end-state__program-options" />
        <Tappable
          href="/invite-friends/?rewards-calc=open"
          target="_blank"
          rel="noopener noreferrer"
          className="end-state__btn"
          onClick={openRewardsCalcModal}
        >
          {
            hasUGAccess ? (descSst.btnText) : (desc.btnText)
          }
        </Tappable>
      </div>
    </Modal>
  );
};

export default EndStateModal;
